<template>
    <div class="campaign-integreations-container">
        <b-loading :is-full-page="isFullPage" :active.sync="showLoader"></b-loading>
        <Integrations 
            v-bind:integrations="campaign_integrations"
            v-bind:integration_for="'campaign'"
            v-on:enableIntegration="toggleIntegrationStatus"
            v-on:disableIntegration="toggleIntegrationStatus" />
    </div>
</template>
<script>
import { mapGetters, mapState } from 'vuex';
import Integrations from './../../../../Settings/Integrations/partials/Integrations';

// this is obsolete - integrations is at the global level - see Settings/Integrations
export default {
    name: 'CampaignIntegration',
    components: {
        Integrations
    },
    computed: {
        ...mapGetters('campaigns', [
            'currentCampaign',
            'campaign_integrations'
        ]),
        ...mapGetters('authentication', [
            'company'
        ]),
        /*...mapState('settings', {
            company: (state) => state.company
        })*/
    },
    data() {
        return {
            showLoader: false,
            isFullPage: false
        };
    },
    created() {
        this.getCampaignIntegrations();
    },
    methods: {
        getCampaignIntegrations() {
            this.showLoader = true;
            return this
                .$store
                .dispatch('campaigns/getCampaignIntegrations', {
                    data: {
                        campaign_id: this.currentCampaign.id,
                    }
                })
                .finally(() => {
                    this.showLoader = false;
                });
        },
        toggleIntegrationStatus(payload) { 
            const { integration_id, enable: integration_added } = payload.data;
            this.showLoader = true;
            this
                .$store
                .dispatch('campaigns/updateCampaignIntegrationStatus', {
                    data: {
                        campaign_id: this.currentCampaign.id,
                        integration_id,
                        integration_added
                    }
                })
                .finally(() => {
                    this.showLoader = false;
                });
        }
    }
}
</script>
<style lang="scss" scoped>
.campaign-integreations-container {
    margin-top: 40px;
}
</style>
